// @flow strict
import React from 'react'

type Props = {
  className?: string,
}

const MenuClose = (props: Props) => (
  <svg
    className={props.className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 28.22 28.22"
  >
    <title>An icon that closes the menu</title>
    <defs />
    <g id="Layer_2" data-name="Layer 2">
      <polygon
        className="cls-1"
        points="28.22 2.83 25.4 0 14.11 11.28 2.83 0 0 2.83 11.28 14.11 0 25.4 2.83 28.22 14.11 16.94 25.4 28.22 28.22 25.4 16.94 14.11 28.22 2.83"
        id="Layer_1-2"
        data-name="Layer 1"
      />
    </g>
  </svg>
)

export default MenuClose
